<template>
  <BaseModalConfirm
    ref="BaseModalConfirmRef"
    :value="value"
    :title="$tc('modalConfirm.recaptcha.title')"
    :text="$tc('modalConfirm.recaptcha.text')"
    @input="$emit('input', $event)"
  >
    <div class="recaptcha-wrapper">
      <Recaptcha
        @error="$emit('recaptcha-error', $event)"
        @success="$emit('recaptcha-success', $event)"
        @expired="$emit('recaptcha-expired', $event)"
      />
    </div>
  </BaseModalConfirm>
</template>
<script>
import BaseModalConfirm from '~/components/Base/Modal/Confirm'

export default {
  name: 'ModalRecaptcha',
  components: { BaseModalConfirm },
  props: {
    value: { type: Boolean },
  },
  methods: {
    async $open() {
      return await this.$refs.BaseModalConfirmRef.$open()
    },
    $submit() {
      return this.$refs.BaseModalConfirmRef.$submit()
    },
  },
}
</script>

<style lang="scss" scoped>
  .recaptcha-wrapper {
    margin-top: 40px;
  }
</style>
